import { useState } from 'react';
import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  const [imgErrors, setImgErrors] = useState<Record<number, boolean>>({});

  const handleImgError = (idx: number) => {
    setImgErrors((prev) => ({ ...prev, [idx]: true }));
  };

  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500">深度报道与独家调查，吃瓜也要吃出门道</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[2/1] bg-background-200 overflow-hidden">
                {!imgErrors[i] ? (
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={() => handleImgError(i)}
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center">
                    <i className="ri-image-line text-5xl text-background-400"></i>
                  </div>
                )}
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-[10px] font-bold text-white ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent"></div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-3 flex-1 line-clamp-3">
                  {item.desc}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.reads} 阅读</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}